import React, { Children } from 'react';

function getListStyleType(type) {
    switch (type) {
        case 'bullet':
            return 'list-disc';
        case 'number':
            return 'list-decimal';
        default:
            return '';
    }
}
const List = ({ className = '', type = 'bullet', children, ...restProps }) => {
    const Component = type === 'number' ? 'ol' : 'ul';
    // Since the list uses `list-style-position: outside;` (by default) we need to add a little padding (of 2ch)
    // when its type is either `bullet` or `number` so it aligns with the rest of elements.
    const listClasses = [/^(bullet|number)$/.test(type) ? 'pl-list' : ''];
    return (React.createElement(Component, { className: [
            'list-outside',
            listClasses,
            getListStyleType(type),
            className,
        ].join(' ') }, Children.map(children, (listItem, key) => {
        return (React.createElement("li", { key: key, className: [
                type === 'icon' ? 'flex items-center' : '',
                key > 0 ? 'pt-2' : '',
            ].join(' ') }, (() => {
            if (type === 'icon' && 'icon' in restProps) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "flex-shrink-0 mr-2", "aria-hidden": "true" }, restProps.icon),
                    listItem));
            }
            return listItem;
        })()));
    })));
};

export { List };
//# sourceMappingURL=List.js.map
